import * as React from 'react';
import { useBeforeunload } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { visuallyHidden } from '@mui/utils';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Checkbox from '@mui/material/Checkbox';
import TableSortLabel from '@mui/material/TableSortLabel';
import { alpha } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import TextField from '@mui/material/TextField';
import TablePagination from '@mui/material/TablePagination';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { useSelector, useDispatch } from 'react-redux';
import store from '../../store';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { useState, useEffect } from 'react';
import useAuth from '../../hooks/useAuth';
import { useNavigate,Link,Location, useLocation } from 'react-router-dom';
import DownloadIcon from '@mui/icons-material/Download';
import exportFromJSON from 'export-from-json';
import { LoadingButton } from '@mui/lab';
import * as XLSX from "xlsx";
import { Fab } from '@mui/material';
import { Download } from '@mui/icons-material';

function Row(props) {
  const dispatch = useDispatch();
  const { row } = props;
  //console.log(row.items);
  // const isItemSelected = isSelected(row.id);
  // const labelId = `enhanced-table-checkbox-${index}`;
  const navigate = useNavigate();
  const handleEdit = (data)=>{
    navigate('/updateVendor', { state: {
      vendor: data
    } });
  };

  const handleOrderSelectionChange = (event) => {
    if(event.target.checked)
    {
      //console.log('checked');
      //console.log(event.target.value);
     // dispatch({ type: 'addapprovedorder', payload: event.target.value  });
    }
    else{
     // dispatch({ type: 'undoapprovedorder', payload: event.target.value  });
    }
  };

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell align="center" component="th" scope="row">
          {row.id}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {row.name}
        </TableCell>
        <TableCell align="center">{row.acNo}</TableCell>
        <TableCell align="center">{row.ifsc}</TableCell>
        <TableCell align="center">{<button type="button" onClick={() => handleEdit(row)} className="btn btn-success">
            Edit
        </button>}</TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    name: PropTypes.string.isRequired,
    // department: PropTypes.string.isRequired,
    // requestor: PropTypes.string.isRequired,
    // items: PropTypes.array.isRequired,
    // orderStatus: PropTypes.string.isRequired,
    // issuedby: PropTypes.string.isRequired,
    // recievedby: PropTypes.string.isRequired,
  }).isRequired,
};


//copied from sorting and selecting
function descendingComparator(a, b, orderBy) {
    if (b[orderBy]??"" < a[orderBy]??"") {
      return -1;
    }
    if (b[orderBy]??"" > a[orderBy]??"") {
      return 1;
    }
    return 0;
  }
  
  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  
  // Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
  // stableSort() brings sort stability to non-modern browsers (notably IE11). If you
  // only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
  // with exampleArray.slice().sort(exampleComparator)
  function stableSort(array, comparator) {
    //console.log('In Stable sort');
    const stabilizedThis = Array.from(array).map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    //console.log('Out Stable sort');
    return stabilizedThis.map((el) => el[0]);
  }
  
  const headCells = [
    {
      id: 'id',
      numeric: true,
      disablePadding: true,
      label: 'ID',
    },
    {
      id: 'name',
      numeric: false,
      disablePadding: true,
      label: 'Name',
    },
    {
      id: 'acNo',
      numeric: false,
      disablePadding: false,
      label: 'Bank A/C Number',
    },
    {
      id: 'ifsc',
      numeric: false,
      disablePadding: false,
      label: 'IFSC',
    },
    // {
    //   id: 'requestor',
    //   numeric: false,
    //   disablePadding: false,
    //   label: 'Requestor',
    // },
    // {
    //   id: 'orderStatus',
    //   numeric: false,
    //   disablePadding: false,
    //   label: 'Status',
    // },
    // {
    //     id: 'issuedby',
    //     numeric: false,
    //     disablePadding: false,
    //     label: 'Issued by',
    //   },
    //   {
    //     id: 'recievedby',
    //     numeric: false,
    //     disablePadding: false,
    //     label: 'Recieved by',
    //   },
  ];
  
  function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
      props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
  
    return (
      <TableHead>
        <TableRow className='info'>
        
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              //align='center'
              align={headCell.numeric ? 'center' : 'center'}
              //text-align={headCell.numeric ? 'right' : 'left'}
              padding={headCell.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'desc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
          <TableCell/>
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  function EnhancedTableToolbar(props) {
    const { numSelected, setFilterSwitch, syncing, onSyncClick } = props;
  
    const handleFilter = (event) => {
      //console.log(`In handleFilter : ${event.target.value}`);
      //rows = rows.filter(row => row.department.includes(event.target.value));
      setFilterSwitch(event.target.value);
      //console.log(`rows count : ${rows.length}`)              
    };

    return (
      <Toolbar
        sx={{
          display:"flex", 
          justifyContent:"space-between",
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
          ...(numSelected > 0 && {
            bgcolor: (theme) =>
              alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
          }),
        }}
      >
        <TextField id="deptFilter" label="Search" variant="standard" onChange={handleFilter} />
        <LoadingButton loading={syncing} variant="contained" onClick={onSyncClick}>Sync Vendors</LoadingButton>
      </Toolbar>
    );
  }
  
  EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
    setFilterSwitch: PropTypes.func,
    syncing: PropTypes.bool,
    onSyncClick: PropTypes.func,
  };

//end copying from sorting and selecting

export default function CollapsibleTable() {

  // const approverRoles = ['Administrator'];
  //console.log('in collapsible table');
  const REQUEST_URL="/PaymentApproval/GetVendors";
  const SYNC_URL = "/PaymentApproval/SyncVendors";
	const {auth,setAuth} = useAuth();
  const axiosPrivate = useAxiosPrivate();
  //let rows = [];

  // need to fetch data from api
  const [rows,setVendorRows] = React.useState([]);

  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     // Perform actions before the component unloads
  //     console.log('History page unloading');
  //     event.preventDefault();
  //     event.returnValue = '';
  //   };
  //   window.addEventListener('beforeunload', handleBeforeUnload);
  //   return () => {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //   };
  // }, []);


  //setting data in redux store
  const dispatch = useDispatch();
   
  
  useEffect(() => {
    //let rows = [];
    //useSelector(() => store.getState().orderitem.ApprovalOrders);
    //const approvedOrders = useSelector(() => store.getState().order.approvedorders);
    // console.log(`Rows key length : ${Object.keys(rows).length}`);
    if(Object.keys(rows).length === 0)
    {
      //console.log('start of get');
      try{
            //console.log(`Bearer ${auth.accessToken}`)
            const response = axiosPrivate.get(REQUEST_URL,{
                withCredentials: true,
                headers: {
                  'content-type': 'application/json',
                  'Authorization': `Bearer ${auth?.accessToken}`
                  //'access-control-allow-origin' : '*'
                }
              })
              .then(response =>{
                //console.log(response.data);
                //console.log(`Response : ${JSON.stringify(response.data)}`);
                setVendorRows(response.data);
                //rows = response.data;
                //dispatch({ type: 'addOrders', payload: response.data  });
                //console.log(`Rows : ${JSON.stringify(rows)}`);
                
              })
              .catch(error =>{
                console.log(error);
              });
          
        }
        catch(err){

            console.log(err.response);

        }

    }
  }, []);
 

  

  //console.log([...rows]);

    //start copy from sorting and selecting

  const [order, setOrder] = React.useState('desc');
  const [orderBy, setOrderBy] = React.useState('id');
  const [filterSwitch, setFilterSwitch] = React.useState('');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [syncing, setSyncing] = React.useState(false);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    //console.log('setOrder');
    setOrder(isAsc ? 'desc' : 'asc');
    //console.log('setOrderby');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.name);
      //console.log('setSelected')
      setSelected(newSelected);
      return;
    }
    //console.log('setSelected empty')
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    //console.log('setSelected handleclick')
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    //console.log('setpage');
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    //console.log('setRowsPerPage');
    setRowsPerPage(parseInt(event.target.value, 10));
    //console.log('setpage 1');
    setPage(0);
  };

  const handleChangeDense = (event) => {
    //console.log('setdense');
    setDense(event.target.checked);
  };

  const onSyncClick = (event) => {
		setSyncing(true);
		const response = axiosPrivate.get(SYNC_URL,{
      withCredentials: true,
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${auth?.accessToken}`
        //'access-control-allow-origin' : '*'
      }
    })
    .then(response =>{
      //console.log(response.data);
      //console.log(`Response : ${JSON.stringify(response.data)}`);
      setVendorRows(response.data);
      //rows = response.data;
      //dispatch({ type: 'addOrders', payload: response.data  });
      //console.log(`Rows : ${JSON.stringify(rows)}`);
      
    })
    .catch(error =>{
      console.log(error);
    })
    .finally(()=> {
      setSyncing(false);
    });
	}

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const [filteredRow, visibleRows] = React.useMemo(
    () =>{
      //stableSort(rows, getComparator(order, orderBy))
      //console.log('inside memo');
      const filteredRows = rows.filter(row => row.name.toLowerCase().includes(filterSwitch.toLowerCase())).slice().sort(getComparator(order, orderBy));

      const start = Math.max(Math.min(page * rowsPerPage, filteredRows.length - 1), 0);
      const end = start + rowsPerPage;

      if(page > filteredRows.length/rowsPerPage)
        setPage(Math.round(filteredRows.length/rowsPerPage-1))
      if(page < 0)
        setPage(0)

      return [filteredRows, filteredRows.slice(
        start,
        end,
      )];
    },
    [rows,filterSwitch,order, orderBy, page, rowsPerPage],
  );

    //end copy from sorting and selecting

  const handleDownload = async (e) => {

    let vendorHeading = [['Sr. No.','Beneficiary Name', 'Account No', 'IFSC', 'Bank Name', 'PAN', 'GSTIN', 'Phone', 'Email']];

    const vendorData = filteredRow
      .map(vendor => ({
        srNo: vendor.id,
        name: vendor.name,
        acNo: vendor.acNo,
        ifsc: vendor.ifsc,
        bankName: vendor.bankName,
        pan: vendor.pan,
        gstin: vendor.gstin,
        phone: vendor.phone,
        email: vendor.email
    }));

    let wb = XLSX.utils.book_new(),
      vws = XLSX.utils.json_to_sheet([]);


    XLSX.utils.sheet_add_aoa(vws, vendorHeading);
    XLSX.utils.sheet_add_json(vws, vendorData, { origin: 'A2', skipHeader: true });

    XLSX.utils.book_append_sheet(wb, vws, "Vendors");

    XLSX.writeFile(wb, "Vendors.xlsx");
  };

   


  return (
    <>
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <EnhancedTableToolbar 
        numSelected={selected.length} setFilterSwitch={setFilterSwitch} 
        syncing={syncing} onSyncClick={onSyncClick}/>
        
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
        <TableBody>
          {visibleRows.map((row) => (
            <Row key={row.id} row={row} />
          ))}
        </TableBody>
        </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredRow.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      />
    </Box>
    <Fab style={{position: 'fixed',
      bottom: '2rem',
      right:  '2rem', // Adjust 240px to the width of the drawer
      transition: 'right 0.2s ease',
    }} onClick={ handleDownload } color="success" aria-label="close">
      <Download />
    </Fab>
    <br/>
    <br/>
    </>

  );
}


